export function humanReadableTimeDifferenece(start, end = new Date()) {
	const endTime = new Date(end);
	const startTime = new Date(start);

	//console.log({ endTime, startTime });
	const diff = endTime - startTime;
	const seconds = Math.floor(Math.abs(diff) / 1000);
	const minutes = Math.floor(seconds / 60);
	const hours = Math.floor(minutes / 60);
	const days = Math.floor(hours / 24);

	if (diff < 0) {
		return "in the future";
	}

	if (days > 0) {
		return `${days} day${days > 1 ? "s" : ""} ago`;
	} else if (hours > 0) {
		return `${hours} hour${hours > 1 ? "s" : ""} ago`;
	} else if (minutes > 0) {
		return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
	} else if (seconds > 0) {
		return `${seconds} second${seconds > 1 ? "s" : ""} ago`;
	} else {
		return "just now";
	}
}
export function toMysqlDateTime(dateObject) {
	return dateObject.toISOString().slice(0, 19).replace("T", " ");
}
window.humanReadableTimeDifferenece = humanReadableTimeDifferenece;
